class ResponsiveBackgroundManager {
  constructor() {
    this.currentMode = null;
    this.loadedImages = new Map();
    this.observer = null;
    this.elements = [];
    this.breakpoint = 1024;

    this.init();
  }

  init() {
    document.addEventListener('DOMContentLoaded', () => {
      this.setupElements();
      this.setupIntersectionObserver();
      this.switchImages();
    });

    window.addEventListener('resize', this.debounce(() => {
      this.switchImages();
    }, 250));

    window.addEventListener('orientationchange', () => {
      setTimeout(() => this.switchImages(), 100);
    });
  }

  setupElements() {
    this.elements = Array.from(document.querySelectorAll('.change-bg'));
  }

  setupIntersectionObserver() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.loadImageForElement(entry.target);
        }
      });
    }, {
      rootMargin: '50px'
    });

    this.elements.forEach(el => {
      this.observer.observe(el);
    });
  }

  async loadImageForElement(element) {
    const mode = this.getCurrentMode();
    const targetSrc = element.dataset[mode];

    if (!targetSrc) return;

    try {
      await this.preloadImage(targetSrc);
      element.style.backgroundImage = `url('${targetSrc}')`;
      element.classList.add('image-loaded');
    } catch (error) {
      console.warn('画像の読み込みに失敗:', targetSrc);
    }
  }

  preloadImage(src) {
    return new Promise((resolve, reject) => {
      if (this.loadedImages.has(src)) {
        resolve(src);
        return;
      }

      const img = new Image();
      img.onload = () => {
        this.loadedImages.set(src, true);
        resolve(src);
      };
      img.onerror = reject;
      img.src = src;
    });
  }

  getCurrentMode() {
    return window.matchMedia(`(max-width: ${this.breakpoint - 1}px)`).matches ? 'sp' : 'pc';
  }

  async switchImages() {
    const mode = this.getCurrentMode();
    if (mode === this.currentMode) return;

    this.currentMode = mode;

    // 画面内の要素のみ処理
    const visibleElements = this.elements.filter(el => {
      const rect = el.getBoundingClientRect();
      return rect.top < window.innerHeight && rect.bottom > 0;
    });

    for (const element of visibleElements) {
      await this.loadImageForElement(element);
    }
  }

  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
}

// 初期化
new ResponsiveBackgroundManager();
